const C = require("../constants");

const openPrinterSettingsModal = modal => {
    return {
        type: C.OPEN_MODAL_PRINTER_SETTINGS,
        modal
    }
};

export {openPrinterSettingsModal};


// WEBPACK FOOTER //
// ./src/actions/PrinterSettingsModalAction.js